import { useCallback, useEffect, useRef, useState } from "react";
import { observeScrollEnd, type ScrollEndOptions } from "@/lib/observe-scroll-end";

export function useScrollEnd({
  panelSelector,
  captureScroll = false,
  observeCharacterData = false,
}: ScrollEndOptions = {}) {
  const [atEnd, setAtEnd] = useState(false);
  const cleanup = useRef<(() => void) | null>(null);
  const attach = useCallback((node: HTMLDivElement | null) => {
    cleanup.current?.();
    cleanup.current = node ? observeScrollEnd(node, setAtEnd, {
      panelSelector, captureScroll, observeCharacterData,
    }) : null;
  }, [panelSelector, captureScroll, observeCharacterData]);

  useEffect(() => () => cleanup.current?.(), []);
  return { atEnd, attach };
}